import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tag } from 'components/atoms/tag';
import { FilterCriteriaAsText } from 'components/organisms/dashboard/filter-as-text';
import {
  GroupCriteria,
  GroupedFilter,
} from 'components/organisms/tasks/grouped-filter-popover';
import { getRandomColor } from 'utils/get-random-color';
import { TagWrapper, BadgeWrapper } from './styles';

const maxVisibleFilters = 3;

const FilterCriteriaBadge = (fieldFilter: GroupCriteria) => {
  const { criteria } = fieldFilter;

  const color = getRandomColor(Math.abs(criteria.field.fieldId));

  return (
    <TagWrapper key={criteria.field.fieldId}>
      <Tag color={color}>
        <FilterCriteriaAsText criterion={criteria} />
      </Tag>
    </TagWrapper>
  );
};

export const GroupedFilterDrawerBadges: FC<{
  filter: GroupedFilter;
  showMinimumBadges?: boolean;
}> = ({ filter: _filter, showMinimumBadges }) => {
  const { groupCriteria } = _filter;
  const renderCriteria = showMinimumBadges
    ? groupCriteria.slice(0, maxVisibleFilters)
    : groupCriteria;

  const countBadgeColor = getRandomColor(maxVisibleFilters);

  return (
    <BadgeWrapper>
      {renderCriteria.map(FilterCriteriaBadge)}
      {showMinimumBadges && groupCriteria.length > maxVisibleFilters ? (
        <TagWrapper>
          <Tag color={countBadgeColor}>
            <FormattedMessage
              id="templates.status_updates.tab.config.publish.projects.filtered.more"
              values={{
                count: groupCriteria.length - maxVisibleFilters,
              }}
            />
          </Tag>
        </TagWrapper>
      ) : null}
    </BadgeWrapper>
  );
};
